





























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { dictServe, institutionServer, performanceServer, professionServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class ChoiceCheckDialog extends Vue {
  @Watch('formData.checkDepartmentId')
  public watchAreaName(newValue: any, oldValue: any) {
    if (oldValue && newValue && this.areaNameVisible) {
      this.formData.checkStaffIds = '';
    }
    if (this.formData.checkDepartmentId === '') {
      this.formData.checkStaffIds = '';
    }
  }

  @Watch('formData.executeDepartmentId')
  public watchExecuteDepartmentName(newValue: any, oldValue: any) {
    if (oldValue && newValue && this.executeDepartmentVisible) {
      this.formData.executeStaffIds = '';
      this.formData.executePostId = '';
    }
    if (newValue === '') {
      this.formData.executeStaffIds = '';
      this.formData.executePostId = '';
    }
  }

  private areaNameVisible = false;
  private dialogVisible = false;
  private executeDepartmentVisible = false;
  private dialogImageUrl = '';

  private visible = false;
  fileList: any = [];
  parentTaskName: any = '';
  finishWayOptions: any = [
    {
      name: '同步完成',
    },
    {
      name: '独立完成',
    },
  ];

  newOptions: any = [
    {
      name: '固定',
    },
    {
      name: '动态',
    },
  ];
  headers: any = {};
  actionUrl: any = '';
  performanceTitle: any = '';
  performanceLevel: any = '';

  private timeRange: any = [];

  executeDepartmentOptions: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [];

  // 人员
  spaceStaffByAuthOptions: any = [];

  // 人员
  spaceStaffTwoByAuthOptions: any = [];

  // 职务
  spacePostByAuthOptions: any = [];

  // 任务
  taskOptions: any = [];

  formData: any = {
    id: '',
    annex: '',
    checkDepartmentId: '',
    checkDepartmentName: '',
    checkPostId: '',
    checkPostName: '',
    checkStaffIds: '',
    endTime: '',
    executeDepartmentId: '',
    executeDepartmentName: '',
    executePostId: '',
    executePostName: '',
    executeStaffIds: '',
    finishWay: '',
    name: '',
    parentTaskId: '',
    remark: '',
    startTime: '',
    type: '',
    taskNature: '固定',
  };

  userRules: any = {
    name: [{ required: true, trigger: 'blur', message: '请填写任务名称' }], // 任务名称
    executeDepartmentId: [{ required: true, trigger: 'blur', message: '请选择执行部门' }], // 执行部门
    // timeRange: [{ required: true, trigger: 'blur', message: '请选择任务时间' }], // 任务时间
    // type: [{ required: true, trigger: 'blur', message: '请选择任务类型' }], // 任务类型
    finishWay: [{ required: true, trigger: 'blur', message: '请选择完成方式' }], // 完成方式
    taskNature: [{ required: true, trigger: 'blur', message: '请选择任务性质' }], // 完成方式
  };

  private async showAddDialog(type: any, level: any, data: any) {
    this.formData = {
      id: '',
      annex: '',
      checkDepartmentId: '',
      checkDepartmentName: '',
      checkPostId: '',
      checkPostName: '',
      checkStaffIds: '',
      endTime: '',
      executeDepartmentId: '',
      executeDepartmentName: '',
      executePostId: '',
      executePostName: '',
      executeStaffIds: '',
      finishWay: '同步完成',
      name: '',
      parentTaskId: '',
      remark: '',
      startTime: '',
      type: '',
      taskNature: '固定',
    };
    this.fileList = [];
    if (data) {
      this.timeRange = [data.startTime, data.endTime];
    } else {
      this.timeRange = [];
    }
    this.formData.name = data.name || '';
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
    this.performanceTitle = type;
    this.performanceLevel = level;
    this.formData.parentTaskId = data.id;
    // this.parentTaskName = data.name;
    this.taskOptions = [];
    this.spacePostByAuthOptions = [];
    this.spaceStaffByAuthOptions = [];
    this.spaceStaffTwoByAuthOptions = [];
    this.executeDepartmentList();
    this.getSubSpaceByAuth();
    // this.getSpacePostByAuth();
    this.getTask();
    this.visible = true;
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.fileList = [];
    this.timeRange = [];
    this.visible = false;
  }

  closeImgDialog() {
    this.dialogVisible = false;
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  executeDepartmentList() {
    institutionServer.getDeptAndSubDeptList({}).then((res: any) => {
      this.executeDepartmentOptions = arrayToTree(res.data);
    });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
        this.$forceUpdate();
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffTwoByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffTwoByAuthOptions = res.data;
        this.$forceUpdate();
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取职务数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpacePostByAuth(id: any) {
    // 发起接口请求，获取分页数据
    professionServer
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spacePostByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取任务类型数据
   * @param1 暂无
   * @returns 暂无
   */
  getTask() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('dutyTaskType')
      .then((res: any) => {
        for (const i in res.data) {
          this.taskOptions.push({
            value: i,
            label: res.data[i],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  chooseCheckStaffIds(data: boolean) {
    if (data && !this.formData.checkDepartmentId) {
      this.$message.warning('请先选择【审核部门】才会有对应的数据！');
    }
    if (this.formData.checkDepartmentId && this.spaceStaffByAuthOptions.length === 0) {
      this.$message.warning('此【审核部门】无对应【审核人员】的数据！');
    }
  }

  chooseExecuteStaffIds(data: boolean) {
    if (data && !this.formData.executeDepartmentId) {
      this.$message.warning('请先选择【执行部门】才会有对应的数据！');
    }
    if (this.formData.executeDepartmentId && this.spaceStaffTwoByAuthOptions.length === 0) {
      this.$message.warning('此【执行部门】无对应【执行人员】的数据！');
    }
  }

  chooseExecute1StaffIds(data: boolean) {
    if (data && !this.formData.executeDepartmentId) {
      this.$message.warning('请先选择【执行部门】才会有对应的数据！');
    }
    if (this.formData.executeDepartmentId && this.spacePostByAuthOptions.length === 0) {
      this.$message.warning('此【执行部门】无对应【执行人员】的数据！');
    }
  }

  // 当区域的下拉出现
  private areaNameChange(data: boolean) {
    this.areaNameVisible = data;
  }

  // 当区域的下拉出现
  private executeDepartmentChange(data: boolean) {
    this.executeDepartmentVisible = data;
  }

  private getAll(data: any) {
    this.formData.checkStaffIds = '';
    if (data) {
      this.getSpaceStaffByAuth(data);
    } else {
      this.spaceStaffByAuthOptions = [];
    }
  }

  private getTwoAll(data: any) {
    this.formData.executeStaffIds = '';
    this.formData.executePostId = '';
    if (data) {
      this.getSpaceStaffTwoByAuth(data);
      this.getSpacePostByAuth(data);
    } else {
      this.spaceStaffTwoByAuthOptions = [];
      this.spacePostByAuthOptions = [];
    }
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      if (this.timeRange.length === 0) {
        this.$message.warning('请选择任务时间');
        return;
      }
      this.addFunctionData();
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async addFunctionData() {
    this.subSpaceByAuthOptions.map((res: any) => {
      if (res.id === this.formData.checkDepartmentId) {
        this.formData.checkDepartmentName = res.name;
      }

      if (res.id === this.formData.executeDepartmentId) {
        this.formData.executeDepartmentName = res.name;
      }
    });

    this.spacePostByAuthOptions.map((res: any) => {
      if (res.id === this.formData.executePostId) {
        this.formData.executePostName = res.name;
      }
    });

    // if (this.formData.parentTaskId) {
    //   this.formData.name = this.parentTaskName + '--子任务：' + this.formData.name;
    // }
    this.formData.startTime = this.timeRange ? (this.timeRange[0] ? this.timeRange[0] : null) : null;
    this.formData.endTime = this.timeRange ? (this.timeRange[1] ? this.timeRange[1] : null) : null;
    this.formData.checkStaffIds = this.formData.checkStaffIds !== '' ? this.formData.checkStaffIds.toString() : null;
    this.formData.executeStaffIds = this.formData.executeStaffIds !== '' ? this.formData.executeStaffIds.toString() : null;
    performanceServer
      .addPerformanceData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.returnDialog(); // 返回到父级页面
          this.$emit('refreshData');
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('添加失败');
      });
  }

  private handleRemove(file: any, fileList: any) {
    const newArr: any = this.formData.annex.split(',');
    newArr.forEach((item: any, index: any) => {
      if (file.response) {
        if (item === file.response.data[0].id) {
          newArr.splice(index, 1);
        }
      } else {
        newArr.splice(index, 1);
      }
    });
    this.formData.annex = newArr.toString();
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    if (file.response.data) {
      const arr: any = [];
      fileList.forEach((item: any) => {
        if (item.response) {
          arr.push(item.response.data[0].id);
        } else {
          arr.push(item.name);
        }
      });
      this.formData.annex = arr.toString();
    } else {
      this.handleRemove1(file, '');
    }
  }

  private handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  private handleRemove1(file: any, fileList: any) {
    console.log(file, '5345');
  }
}
